import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import ConfigData from "../../master/components/ConfigData";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { EmptyCollection, ExportMenu, FilterComponent, Pagination, ImportMenu, DeletePopUp, PageLoader, STableLoader, RevisionHistory } from "../../../shared_elements";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import AircraftTypesList from "../component/AircraftTypesList";
import AddEditAircraftTypes from "../component/AddEditAircraftTypes";
import { trackActivity } from "../../../../utils/mixpanel";
import AddIcon from '@material-ui/icons/Add';
import { aircraftTypesFilters } from "..";

const AircraftTypeObj = {
    name: null,
    aircraft_body_type:null,
    no_of_engines: null,
    no_of_landing_gears: null,
    aircraft_family: null,
    remarks: null,
    has_propeller: false,
    has_apu:false
    
}

const AircraftTypesHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
    return (
        <TableHead>
            <TableRow >
               <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} ><div style={{ width: '130px' }}> {checkPermission('config_data', 'aircraft_types', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" /> }Action(s)</div></TableCell>
                <TableCell >
                    <div style={{ width: '100px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '120px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'no_of_engines' ? true : false}
                        direction={sortInfo.sort === 'no_of_engines' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('no_of_engines')}
                    >
                        No. Of Engines
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '155px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'no_of_landing_gears' ? true : false}
                        direction={sortInfo.sort === 'no_of_landing_gears' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('no_of_landing_gears')}
                    >
                        No. Of Landing Gears
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '140px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'aircraft_family' ? true : false}
                        direction={sortInfo.sort === 'aircraft_family' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('aircraft_family')}
                    >
                        Aircraft Family
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '150px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'aircraft_body_type' ? true : false}
                        direction={sortInfo.sort === 'aircraft_body_type' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('aircraft_body_type')}
                    >
                        Aircraft Body Type
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell style={{ width: '100px' }}>Has Propeller</TableCell>
                <TableCell style={{ width: '100px' }}>Has Apu</TableCell>
                <TableCell >
                    <div style={{ width: '140px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '140px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                    </div>
                </TableCell>
                <TableCell >
                    <div style={{ width: '200px' }}>
                    <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel>
                    </div>
                </TableCell>
            </TableRow>
        </TableHead >
    )
}

const AircraftTypes = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState({});
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [deleteAircraftTypes, setDeleteAircraftTypes] = useState({ modal: false, data: null });
    const [revertAircraftTypes, setRevertAircraftTypes] = useState({ modal: false, data: null });
    const [addEditAircraftTypes, setAddEditAircraftTypes] = useState({ modal: false, data: null, type: '' });
    const [aircraftTypesInfo, setAircraftTypesInfo] = useState({ list: [], pagination: {} });
    const [aircraftFamilyFilter, setAircraftFamilyFilter] = useState([]);
    const [acBodyTypeFilter, setAcBodyTypeFilter] = useState([])

    useEffect(() => {
        getAirCraftTypes({per_page:50},"skeletonLoader");
        trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types', event_type: 'Page Visited' });
        getAcBodyType();
        getAircraftFamily();
    }, [])

    const getAirCraftTypes = (query={}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/aircraft-type/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftTypesInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteAircraftTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftTypesInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteAircraftTypes.data.id

        globalDeleteService(`config-data/aircraft-type/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteAircraftTypes({ modal: false, data: null });
                    getAirCraftTypes({...filter, page: aircraftTypesInfo?.pagination?.page, per_page: aircraftTypesInfo?.pagination?.per_page}, 'pageLoader');
                    setLoading(false);
                    setCurrentPage({});
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Types Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteAircraftTypes({ modal: false, data: null });
                    setLoading(false);
                    setBulkDelete({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Types',
                        event_type: `Item Deleted`,
                        event_desc: 'Aircraft Types Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertAircraftTypes.data ? Object.values(pageSelections).flat().filter(id => {
            const item = aircraftTypesInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertAircraftTypes.data;

        globalPutService(`config-data/aircraft-type/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertAircraftTypes({ modal: false, data: null });
                    getAirCraftTypes({...filter, page: aircraftTypesInfo?.pagination?.page, per_page: aircraftTypesInfo?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false)
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Types Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertAircraftTypes({ modal: false, data: null });
                    setLoading(false);
                    setBulkRevert({ modal: false, data: null })
                    setPageSelections({});
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Aircraft Types',
                        event_type: `Item Reverted`,
                        event_desc: 'Aircraft Types Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = aircraftTypesInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = aircraftTypesInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };

    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getAirCraftTypes({ ...filter, ...sortQuery, page: 1, per_page: aircraftTypesInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }
    
    const isSelectAllChecked = aircraftTypesInfo?.list?.length > 0 && pageSelections[currentPage]?.length === aircraftTypesInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertAircraftTypes?.modal || bulkRevert?.modal) return "primary";
        if (deleteAircraftTypes?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertAircraftTypes?.modal || bulkRevert?.modal) return "Revert";
        if (deleteAircraftTypes?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertAircraftTypes?.modal) return revertAircraftTypes.modal;
        if (deleteAircraftTypes?.modal) return deleteAircraftTypes.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertAircraftTypes?.modal) return "Revert Aircraft Types";
        if (deleteAircraftTypes?.modal) return "Delete Aircraft Types";
        if (bulkDelete?.modal) return `Delete Aircraft Types (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Aircraft Types (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertAircraftTypes?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteAircraftTypes?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertAircraftTypes?.modal) {
            setRevertAircraftTypes({ modal: false, data: null });
        } else if (deleteAircraftTypes?.modal) {
            setDeleteAircraftTypes({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertAircraftTypes?.modal || bulkRevert?.modal) return onRevert;
        if (deleteAircraftTypes?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

    const getAcBodyType = () => {
        globalGetService(`technical/blueprints/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    let data = response.data.data.map(item => { return { label: item?.name, value: item?.id } })
                    setAcBodyTypeFilter(data)
                }
            })
    }
    const getAircraftFamily = () => {
        globalGetService(`config-data/aircraft-family/?lite=true`)
            .then(response => {
                if (checkApiStatus(response)) {
                    setAircraftFamilyFilter(response?.data.data)
                }
            })
    }
        
        let filterOption = aircraftTypesFilters
        filterOption={
            ...filterOption,
             aircraft_family:{
                ...filterOption.aircraft_family,
                options:aircraftFamilyFilter
            },
             aircraft_body_type:{
                ...filterOption.aircraft_body_type,
                options:acBodyTypeFilter
            },
            has_propeller: {
                ...aircraftTypesFilters.has_propeller,
                value: false,
            },
            has_apu: {
                ...aircraftTypesFilters.has_apu,
                value: false,
            },
        }

    return (

        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content" style={{ paddingTop: '0px' }}>
                {skeletonLoader ? <STableLoader count={6}  size={9}/> :
                    <div style={{ padding: '10px' }}>
                        <Paper elevation={0} className="console-paper" style={{ padding: '5px 10px', marginBottom: "2px" }}>
                            <Grid container spacing={1} alignItems="center">
                                    <Grid item md={6}>                                
                                            <FilterComponent
                                                filter={filter}
                                                filterMenu={filterOption}
                                                getResponseBack={(applyFilter) => { getAirCraftTypes({ ...applyFilter, page: 1, per_page: aircraftTypesInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                            />
                                    </Grid>
                                <Grid item md={6}>
                                    <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                        {revertCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Aircraft Types` }) }} color="primary" size='small' variant="outlined">
                                                    Revert ({revertCount})
                                                </Button>
                                            </li>
                                        )}
                                        {deleteCount > 0 && (
                                            <li className='list-inline-item'>
                                                <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Types', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Aircraft Types` }) }} color="secondary" size='small' variant="contained">
                                                    Delete ({deleteCount})
                                                </Button>
                                            </li>
                                        )}
                                        {checkPermission('config_data', 'aircraft_types', 'C') &&   <li className='list-inline-item'>
                                            <Button onClick={() => setAddEditAircraftTypes({ modal: true, data: AircraftTypeObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                        </li>}
                                        
                                        <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                            <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdaircrafttype/`} queryParams={{ action: '0,1,2' }} hideLinkage />
                                        </li>
                                      
                                    </ul>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper square>
                          <div style={{ height: `${window.innerHeight - (aircraftTypesInfo?.list?.length ? 200 : 150)}px`, overflow: 'auto' }} >
                            <Table className="mui-table-format" stickyHeader>
                                <AircraftTypesHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                                <TableBody>
                                    {aircraftTypesInfo?.list?.length > 0 && aircraftTypesInfo?.list?.map((item, index) =>
                                        <AircraftTypesList
                                            item={item}
                                            index={index}
                                            onDelete={setDeleteAircraftTypes}
                                            onRevert={setRevertAircraftTypes}
                                            onEditFn={() => setAddEditAircraftTypes({ modal: true, data: item, type: 'edit' })}
                                            toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                            bulkIds={pageSelections[currentPage] || []}
                                        />
                                    )}
                                </TableBody>
                             </Table>
                              {!aircraftTypesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                           </div>
                        </Paper>
                        <Paper square>
                            <Pagination
                                pagination={aircraftTypesInfo?.pagination}
                                onChangePage={(event, newPage) => { getAirCraftTypes({ ...filter, page: newPage + 1, per_page: aircraftTypesInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                                onChangeRowsPerPage={(event) => getAirCraftTypes({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                            />
                        </Paper>
                    </div>}
                </div>
                {addEditAircraftTypes.modal ?
                    <AddEditAircraftTypes
                        addEditAircraftTypes={addEditAircraftTypes}
                        aircraftTypesInfo={aircraftTypesInfo}
                        toggleModalFn={() => setAddEditAircraftTypes({ modal: false, aircraftType: [] })}
                        getResponseBack={() => getAirCraftTypes({...filter, page: aircraftTypesInfo?.pagination?.page, per_page: aircraftTypesInfo?.pagination?.per_page}, 'pageLoader')}
                        modeType={addEditAircraftTypes?.type}
                    /> : null
                }
                <DeletePopUp
                    confirmColor={getConfirmColor()}
                    confirmText={getConfirmText()}
                    modal={getModal()}
                    title={getTitle()}
                    content={getContent()}
                    toggleModalFn={toggleModalFn}
                    deleteRecordFn={getDeleteRecordFn()}
                />
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </section>
    )
}
export default AircraftTypes;